<template>
  <modal
    :nextRoute="{name: 'menuIndex',params: { userSlug: rawMenu.user.slug }}"
    :showCloseButton="true"
  >
    <div
      class="text-center my-3 p-3"
      slot="heading"
    >
      <h1 class=" mb-0">
        <span class="font-weight-bold">Contact</span>
      </h1>
      <p class="small mb-0">
        {{rawMenu.user.name}}
      </p>
    </div>
    <div
      slot="content"
      class="p-3"
    >
      <div v-if="success">Your enquiry has been sent to {{rawMenu.user.name}}</div>
      <form
        v-on:submit.prevent="onSubmit"
        v-if="!success"
      >
        <div class="form-group">
          <label for="name">Name</label>
          <input
            v-model="name"
            type="text"
            class="form-control"
            id="name"
            v-bind:class="{ 'is-invalid': errors.name }"
            required
          />
          <small
            v-if="errors.name"
            class="text-danger"
          >{{ errors.name}}</small>
        </div>
        <div class="form-group">
          <label for="email">Email address</label>
          <input
            v-model="email"
            type="email"
            class="form-control"
            id="email"
            v-bind:class="{ 'is-invalid': errors.email }"
          />
          <small
            v-if="errors.email"
            class="text-danger"
          >{{
                            errors.email
                        }}</small>
        </div>
        <div class="form-group">
          <label for="phone">Phone</label>
          <input
            v-model="phone"
            type="text"
            class="form-control"
            id="phone"
            v-bind:class="{ 'is-invalid': errors.phone }"
          />
          <small
            v-if="errors.phone"
            class="text-danger"
          >{{
                            errors.phone
                        }}</small>
        </div>
        <div class="form-group">
          <label for="enquiry">Enquiry</label>
          <textarea
            v-model="enquiry"
            class="form-control"
            id="enquiry"
            v-bind:class="{ 'is-invalid': errors.enquiry }"
            required
          ></textarea>
          <small
            v-if="errors.enquiry"
            class="text-danger"
          >{{errors.enquiry}}</small>
        </div>
        <div
          v-if="emptyRequiredMessage"
          class="text-center text-danger small my-3"
        >
          {{ emptyRequiredMessage }}
        </div>
        <button
          type="submit"
          class="btn btn-primary btn-lg btn-block mt-4"
          v-if="!appProcessing"
        >
          Submit
        </button>
        <formLoader
          v-if="appProcessing"
          class="text-center my-5"
        ></formLoader>
        <div
          v-if="!appProcessing"
          class="small text-center mt-3"
        >
        </div>

      </form>
    </div>
  </modal>
</template>

<style scoped>
</style>

<script>
import formLoader from "../../form/FormLoader";
import modal from "../../shared/Modal";
import pageMixin from "../../../mixins/pageMixin";
import formMixin from "../../../mixins/formMixin";
export default {
  mounted() {
    this.$gtag.pageview({
      page_title: "Contact " + this.rawMenu.user.name,
    });
  },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      enquiry: "",
      emptyRequiredMessage: "",
      success: false,
    };
  },
  metaInfo() {
    return {
      title: "Contact " + this.rawMenu.user.name,
      vmid: "title",
      meta: [
        {
          name: "description",
          vmid: "description",
          content: "Contact " + this.rawMenu.user.name,
        },
        {
          name: "og:title",
          vmid: "ogTitle",
          content: "Contact " + this.rawMenu.user.name,
        },
        {
          name: "og:description",
          vmid: "ogDescription",
          content: "Contact " + this.rawMenu.user.name,
        },
      ],
    };
  },
  methods: {
    onSubmit: function () {
      this.setAppProcessing(true);
      axios
        .post("/api/user/contact", {
          user_id: this.rawMenu.user.id,
          name: this.name,
          email: this.email,
          phone: this.phone,
          enquiry: this.enquiry,
        })
        .then(
          (response) => {
            this.errors = {};
            this.setAppProcessing(false);
            this.success = true;
          },
          (error) => {
            this.setAppProcessing(false);
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            } else {
              this.errors = {};
            }
          }
        );
    },
  },
  components: {
    formLoader,
    modal,
  },
  mixins: [pageMixin, formMixin],
};
</script>
